import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import {
  ResumableUploadResponse,
  UploadSession,
} from '../../core/models/upload-session.model';
import { FilePondComponent } from 'ngx-filepond';
import { FilePondOptions } from 'filepond';
import { CloudUploadService } from '../../core/services/cloud-upload.service';
import { HttpClient } from '@angular/common/http';
import { getUploadResumeURL } from '../../util/const';
import { Observable, firstValueFrom } from 'rxjs';

@Component({
  selector: 'black-multi-file-upload',
  templateUrl: './multi-file-upload.component.html',
  styleUrls: ['./multi-file-upload.component.css'],
  standalone: false,
})
export class MultiFileUploadComponent implements OnInit {
  private uploadService = inject(CloudUploadService);
  private http = inject(HttpClient);

  @ViewChild('myPond')
  myPond!: FilePondComponent;

  @Input()
  selectedCourseId: string | null | undefined = '';

  pondOptions: FilePondOptions = {
    allowMultiple: true,
    labelIdle: 'Drop files here or Browse',
    instantUpload: false,
    allowImagePreview: false,
    credits: false,
  };

  uploadSessions$: Observable<UploadSession[]> = new Observable<
    UploadSession[]
  >();

  ngOnInit(): void {
    this.uploadSessions$ = this.uploadService.uploads$;
  }

  async pondHandleAddFile(event: any) {
    const file = event.file.file;

    if (file) {
      const data = await firstValueFrom(
        this.http.post<ResumableUploadResponse>(getUploadResumeURL(), {
          name: file.name,
          type: file.type,
          size: file.size,
        }),
      );

      if (data) {
        this.uploadService.addUploadFromResponse(file, data);
      }
    }
  }
}
